import { useWidgetLayoutContentSize } from "../useWidgetLayoutContentSize";

export const useRoutineOverviewListItemHeight = () => {
  return useWidgetLayoutContentSize().unit / 4;
};
